<template>
    <div class="row">
        <CallsPerCampaignPenitrationByUser v-for="(dat,index) in data" :user="dat" :key="index"></CallsPerCampaignPenitrationByUser>
    </div>
</template>

<script>
    import CallsPerCampaignPenitrationByUser from './CallsPerCampaignPenitrationByUser';
    export default {
        name: 'UserByCallBase',
        components: {CallsPerCampaignPenitrationByUser},

        data(){
            return {
                data: null,
                interval: Object,
                display: true,
                cur_display_size: 6,
                time_wait: 100000,
                load_url: '/dashboards/GetUsersByCall'
            };
        },
        mounted(){
            this.callAPI();
            this.interaval = setInterval(
                this.callAPI,
                this.time_wait,
            );
        },
        beforeDestroy(){
            clearInterval(this.interaval);
        },
        methods:{
            callAPI: function () {
                var _this = this;
                this.$http.post(this.load_url)
                    .then(response => {
                        _this.data = response.data.data;
                        // console.log(_this.data,response.data);
                    });
            }
        }
    };
</script>

<style scoped>

</style>